import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { VendorGridItemDto, VendorService } from 'src/app/proxy/vendors';
import { AppConsts } from '../../AppConsts';

@Component({
  selector: 'app-vendor-selector',
  standalone: false,
  templateUrl: './vendor-selector.component.html',
})
export class VendorSelectorComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() vendorIdSelected: number | undefined;
  @Input() isDisabled = false;

  @Output() changeSelectedVendor = new EventEmitter<VendorGridItemDto>();
  vendors: VendorGridItemDto[];
  selectedVendor: VendorGridItemDto;

  constructor(
    injector: Injector,
    private readonly _vendorService: VendorService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadVendors();
    this.onSelected();
  }

  async loadVendors(): Promise<void> {
    try {
      this.showLoading();

      const result = await firstValueFrom(this._vendorService.getAllVendorsByInput({
        maxResultCount: AppConsts.MaxPageSize,
        skipCount: 0
      }));

      this.vendors = result.items;
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeSelectedVendor.emit(this.selectedVendor);
  }

  async setSelectedVendorById(vendorId: number): Promise<void> {
    this.vendorIdSelected = vendorId;
    if (this.isNullOrUndefined(this.vendors)) {
      await this.loadVendors();
    }
    
    this.setSelectedVendor();
  }

  private setSelectedVendor(): void {
    if (this.vendors?.length) {
      this.selectedVendor = this.vendors.find(x => x.id === this.vendorIdSelected);
      this.onSelected();
    }
  }
}